import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { join } from '@redux/actions';
import { Button, Col, Row, Form, Input, Select, Alert } from 'antd';

type Props = {};

const Join: React.FC<Props> = () => {
  const { t } = useTranslation('genericScreen');
  const [hasCompletedCourses, setHasCompletedCourses] = useState(false);
  const dispatch = useDispatch();

  const onFinish = (values: any) => {
    dispatch(join(values, hasCompletedCourses));
  };

  return (
    <>
      <Row justify="center" align="top">
        <Col xs={24} sm={16} md={12} lg={10} xl={9} className="p20 whiteContainer mainContainer">
          <h1 className="title">{t('join_now')}</h1>
          <div style={{ display: 'block' }}>
            <Form name="register" onFinish={onFinish}>
              <Input.Group compact>
                <Input
                  disabled
                  value={t('first_name')}
                  style={{ width: '35%', color: 'rgba(0, 0, 0, 0.65)', cursor: 'auto' }}
                />
                <Form.Item
                  style={{ width: '65%' }}
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: t('first_name_validation')
                    }
                  ]}
                >
                  <Input />
                </Form.Item>
              </Input.Group>

              <Input.Group compact>
                <Input
                  disabled
                  value={t('last_name')}
                  style={{ width: '35%', color: 'rgba(0, 0, 0, 0.65)', cursor: 'auto' }}
                />
                <Form.Item
                  style={{ width: '65%' }}
                  name="lastName"
                  rules={[
                    {
                      required: true,
                      message: t('last_name_validation')
                    }
                  ]}
                >
                  <Input />
                </Form.Item>
              </Input.Group>

              <Input.Group compact>
                <Input
                  disabled
                  value={t('email')}
                  style={{ width: '35%', color: 'rgba(0, 0, 0, 0.65)', cursor: 'auto' }}
                />
                <Form.Item
                  style={{ width: '65%' }}
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: t('email_validation')
                    }
                  ]}
                >
                  <Input />
                </Form.Item>
              </Input.Group>

              <Input.Group compact>
                <Input
                  disabled
                  value={t('password')}
                  style={{ width: '35%', color: 'rgba(0, 0, 0, 0.65)', cursor: 'auto' }}
                />
                <Form.Item
                  style={{ width: '65%' }}
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: t('password_validation')
                    },
                    { min: 6, message: 'Password must be minimum 6 characters.' }
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </Input.Group>

              <Input.Group compact>
                <Input
                  disabled
                  value={t('repeat_password')}
                  style={{ width: '35%', color: 'rgba(0, 0, 0, 0.65)', cursor: 'auto' }}
                />
                <Form.Item
                  style={{ width: '65%' }}
                  name="repeat_password"
                  dependencies={['password']}
                  rules={[
                    {
                      required: true,
                      message: t('repeat_password_validation')
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error('The two passwords that you entered do not match!')
                        );
                      }
                    })
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </Input.Group>

              <Alert
                className="mt20"
                message={t('join_us_completed_assessment')}
                description={t('join_us_additional_info')}
                type="info"
                showIcon
              />

              <Form.Item>
                <a href="/tandc">{t('by_registering_i_accept_t_and_c')}</a>
              </Form.Item>

              <div style={{ float: 'left', marginTop: '20px' }}>
                <a className="login-form-forgot" href="/login">
                  {t('login_go')}
                </a>
              </div>
              <Form.Item className="pt20">
                <Button type="primary" htmlType="submit" style={{ float: 'right' }}>
                  {t('register')}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Join;
